import React, { useEffect, useState } from "react";
import axios from "axios";
import "./FlashSale.css";
import { BASE_URL } from "../../constant";
import { useNavigate } from "react-router-dom";

const FlashSale = () => {
  const [flashHeaders, setFlashHeaders] = useState([]);
  const navigate = useNavigate();

  const fetchFlashHeader = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/flash-header/get-all`);
      const texts = response.data.map((text) => text.flashText);
      setFlashHeaders(texts);
    } catch (error) {
      console.error("Failed to fetch Flash Headers.");
    }
  };
  const handleHeaderClick = () => {
    navigate("/sale-products");
  };
  useEffect(() => {
    fetchFlashHeader();
  }, []);

  return (
    <div
      className="marquee-container"
      onClick={handleHeaderClick}
      style={{ cursor: "pointer" }}
    >
      <div className="marquee">
        {flashHeaders.map((header, index) => (
          <span key={index}>{header}</span>
        ))}
      </div>
    </div>
  );
};

export default FlashSale;
